import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { pushPromotionClick, pushPromotionImpression } from '../utils/data-layer.js';
import { BannerRecommendation } from './BannerRecommendation.js';

const BannerRecommendationContainer = ({ recommendation , className , tabIndex ,  })=>{
    const clickRef = React.useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handlePromotionClick = React.useCallback(()=>{
        if (!clickRef.current) {
            clickRef.current = true;
            pushPromotionClick(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(()=>{
        if (wasSeen) {
            pushPromotionImpression(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React.createElement(BannerRecommendation, {
        ref: ref,
        recommendation: recommendation,
        onClick: handlePromotionClick,
        className: className,
        tabIndex: tabIndex
    });
};

export { BannerRecommendationContainer };
//# sourceMappingURL=BannerRecommendationContainer.js.map
